/**
 * Create a one way binding so as the property is updated, the DOM is also updated
 * @param  string property Required - The name of the property to be bound
 * @param  string selector Required the selector that matches the elements to be updated
 * @return void
 */
module.exports = (property, selector) => {
    return {

        //
        get: function () {
            return this._values[property] ?? undefined;
        },

        //
        set: function (value) {

            //
            if (this._values === undefined) {
                this._values = {};
            }

            //
            this._values[property] = value;

            //
            const elements = document.querySelectorAll(selector);
            if (typeof elements !== 'undefined' && elements.length > 0) {
                for (const element of elements) {
                    element.textContent = value;
                }
            }

        }

    }
};